export const breadcrumb = {
  title: 'Звонки',
  trunk: {
    index: 'SIP-транки'
  }
};
